@if ((consultationPopup.shouldShowPopup$ | async)) {
  <div class="fixed bottom-0 left-0 right-0 shadow-lg z-20 px-3 bg-blue bg-opacity-70">
    <div class="py-1 flex space-x-4 justify-end">
      <!-- appointments to display in the ribbon -->
      @for (appointment of appointmentList; track appointmentTrackBy($index, appointment)) {
        <app-consultation-popup-item [appointment]="appointment"></app-consultation-popup-item>
      }
    </div>
  </div>
}
